import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  
  private messageService = inject(MessageService);
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}Errors/`;
  
  handleHttpError(error: HttpErrorResponse): void {
    const msg = this.getHttpMessage(error);
    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: msg,
                        life: 3000,
                    });
    this.logError(error); 
  }

  handleGlobalError(error: any): void {
    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'An unexpected error occurred',
                        life: 3000,
                    });
    this.logError(error);
  }

  private getHttpMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 400: return 'Bad Request';
      case 401: return 'Unauthorized';
      case 403: return 'Forbidden';
      case 404: return 'Not Found';
      case 500: return 'Internal Server Error';
      default: return 'Unexpected error occurred';
    }
  }

  private logError(error: any) {
    this.http.post(this.apiUrl, error).subscribe({
      next: (response) => {
        console.log('Error logged successfully:', response);
      },
      error: (err) => {
        console.error('Failed to log error:', err);
      }
    });    
  }
}
